import { render, staticRenderFns } from "./Catalogue.vue?vue&type=template&id=5e22865d&"
import script from "./Catalogue.vue?vue&type=script&lang=js&"
export * from "./Catalogue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Catalogue.vue"
export default component.exports